export function selectAllUsers(reduxStore) {
  return reduxStore.allUsers.allUsers;
}
